import { useEffect, FC, ReactElement } from "react";

interface OverflowHiddenProps {
    selector?: string;
    children: ReactElement;
}

const getElement = (selector: string): HTMLElement | null => {
    return document.querySelector<HTMLElement>(selector);
};

const hideOverflow = (selector: string, shouldHide: boolean): void => {
    const element = getElement(selector);
    if (shouldHide) {
        if (element == null) {
            throw new ReferenceError("Invalid element selector was provided: " + selector);
        }

        element.style.overflow = "hidden";
        return;
    }

    if (element) {
        element.style.overflow = "";
    }
};

const SideEffectsOverflowHidden: FC<OverflowHiddenProps> = ({ selector = "body", children }: OverflowHiddenProps) => {
    useEffect(() => {
        // on mount
        hideOverflow(selector, true);

        // on unmount
        return (): void => hideOverflow(selector, false);
    }, [selector]);

    return children;
};

export default SideEffectsOverflowHidden;
